import type { Action } from 'src/types';

export enum Actions {
  PERSONAL_DETAILS_UPDATE_START = 'PERSONAL_DETAILS_UPDATE_START',
  PERSONAL_DETAILS_UPDATE_SUCCESS = 'PERSONAL_DETAILS_UPDATE_SUCCESS',
  PERSONAL_DETAILS_UPDATE_FAILURE = 'PERSONAL_DETAILS_UPDATE_FAILURE',
}
export type PersonalDetailsAction =
  | Action<typeof Actions.PERSONAL_DETAILS_UPDATE_START>
  | Action<typeof Actions.PERSONAL_DETAILS_UPDATE_SUCCESS>
  | (Action<typeof Actions.PERSONAL_DETAILS_UPDATE_FAILURE> & {
      payload: Error;
    });
